var ScoringTemplate = function ScoringTemplate(region, sobj) {
  var results_text = 'Region Tied';
  var bonus_events = '';
  var winner_css = 'winner-tied';
  var us_bg = "".concat(sobj.us.bg, " battleground");
  var us_nbg = "".concat(sobj.us.total - sobj.us.bg, " non-battleground");
  var ussr_bg = "".concat(sobj.ussr.bg, " battleground");
  var ussr_nbg = "".concat(sobj.ussr.total - sobj.ussr.bg, " non-battleground");
  if (sobj.us.bg != 1) {
    us_bg += 's';
  }
  if (sobj.ussr.bg != 1) {
    ussr_bg += 's';
  }
  if (sobj.us.total - sobj.us.bg != 1) {
    us_nbg += 's';
  }
  if (sobj.ussr.total - sobj.ussr.bg != 1) {
    ussr_nbg += 's';
  }
  if (sobj.us.vp > sobj.ussr.vp) {
    results_text = "US wins +".concat(sobj.us.vp - sobj.ussr.vp, " VP");
    winner_css = 'winner-us';
  }
  if (sobj.us.vp < sobj.ussr.vp) {
    results_text = "USSR wins +".concat(sobj.ussr.vp - sobj.us.vp, " VP");
    winner_css = 'winner-ussr';
  }
  if (sobj.bonus.length > 0) {
    bonus_events = "\n      <div class=\"scoring-bonus-title\"></div>  \n      <div class=\"scoring-event-grid\"></div>\n    ";
  }
  var usc = "US controls ".concat(us_bg, " and ").concat(us_nbg, " for ").concat(sobj.us.status);
  var ussrc = "USSR controls ".concat(ussr_bg, " and ").concat(ussr_nbg, " for ").concat(sobj.ussr.status);
  usc = usc.replace('and 0 non-battlegrounds ', '');
  ussrc = ussrc.replace('and 0 non-battlegrounds ', '');
  usc = usc.replace('0 battlegrounds and ', '');
  ussrc = ussrc.replace('0 battlegrounds and ', '');
  usc = usc.replace('controls 0 battlegrounds for None', 'has No Presence');
  ussrc = ussrc.replace('controls 0 battlegrounds for None', 'has No Presence');
  usc = usc.replace(' for Thailand', '');
  ussrc = ussrc.replace(' for Thailand', '');
  usc = usc.replace(' for undefined', '');
  ussrc = ussrc.replace(' for undefined', '');
  var html = "\n\n    <div class=\"scoring-overlay ".concat(region, "-scoring ").concat(winner_css, "\">\n\n        <div class=\"card card-hud\"><img class=\"cardimg\" src=\"/twilight/img/en/TNRnTS-01.svg\"><img class=\"cardimg\" src=\"/twilight/img/EarlyWar.svg\"><img class=\"cardimg\" src=\"/twilight/img/BothPlayerCard.svg\"><img class=\"cardimg\" src=\"/twilight/img/MayNotBeHeld.svg\"></div>\n     \n        <div class=\"scoring-box\">\n          <div class=\"scoring-result-title\">").concat(results_text, "</div>   \n\t  <div class=\"scoring-text\">").concat(usc, "</div>\n\t  <div class=\"scoring-text\">").concat(ussrc, "</div>\n          ").concat(bonus_events, "\n\t</div>\n\n    </div>\n\n  ");
  return html;
};
module.exports = ScoringTemplate;